export enum LoginStepEnum {
	username = 0,
	pin = 1
}
